import styled from 'styled-components';

export default styled.ul`
  font-size: 0.8rem;
  text-align: left;
  width: 300px;
  max-width: 100%;
  margin: 1rem auto;
  padding-left: 42px;

  li + li {
    margin-top: 1rem;
  }
`;
